import { render } from "./HouseNameAndFeatures.vue?vue&type=template&id=1767c21d&scoped=true&ts=true&lang=pug"
import script from "./HouseNameAndFeatures.vue?vue&type=script&lang=ts&setup=true"
export * from "./HouseNameAndFeatures.vue?vue&type=script&lang=ts&setup=true"

import "./HouseNameAndFeatures.vue?vue&type=style&index=0&id=1767c21d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1767c21d"]])

export default __exports__